import { Slot } from "@radix-ui/react-slot";
import type { ImgHTMLAttributes } from "react";

import { cn } from "../utils/cn";

interface IconKlarnaProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

function IconKlarna({ className, asChild = false }: IconKlarnaProps) {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn(className)}
      fill="none"
      height="38"
      viewBox="0 0 91 38"
      width="91"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect height="38" width="90.1616" />
      <path
        d="M73.4575 4H16.7041C11.897 4 8 7.89697 8 12.7041V25.2959C8 30.103 11.897 34 16.7041 34H73.4575C78.2647 34 82.1616 30.103 82.1616 25.2959V12.7041C82.1616 7.89697 78.2647 4 73.4575 4Z"
        fill="#FFB3C7"
      />
      <path
        d="M67.3868 17.1445C65.292 15.714 62.4309 16.2574 61.005 18.3521C59.5744 20.4469 60.1179 23.308 62.2126 24.7339C63.7732 25.7976 65.8262 25.7976 67.3868 24.7339V25.2913H69.9924V16.5872H67.3868V17.1445ZM65.0133 23.178C63.7779 23.1129 62.8257 22.0539 62.8907 20.8185C62.9558 19.583 64.0147 18.6308 65.2502 18.6958C66.4393 18.7609 67.3728 19.7409 67.3728 20.9346C67.3403 22.2026 66.2813 23.2058 65.0087 23.1733L65.0133 23.178Z"
        fill="black"
      />
      <path d="M31.6415 12.7087H28.915V25.2958H31.6415V12.7087Z" fill="black" />
      <path
        d="M55.5754 16.3548C54.535 16.2944 53.5318 16.7496 52.8908 17.5717V16.5917H50.2944V25.2958H52.9233V20.7208C52.8444 19.7083 53.6014 18.8258 54.614 18.7515C54.7022 18.7468 54.7905 18.7422 54.8787 18.7515C56.026 18.7515 56.6809 19.4342 56.6809 20.7069V25.3005H59.2865V19.764C59.2865 17.7389 57.6748 16.3595 55.5754 16.3595V16.3548Z"
        fill="black"
      />
      <path
        d="M39.8905 17.1445C37.7957 15.714 34.9346 16.2574 33.5086 18.3521C32.0781 20.4469 32.6215 23.308 34.7163 24.7339C36.2769 25.7976 38.3298 25.7976 39.8905 24.7339V25.2913H42.4961V16.5872H39.8905V17.1445ZM37.517 23.178C36.2815 23.1129 35.3294 22.0586 35.3944 20.8185C35.4594 19.583 36.5138 18.6308 37.7539 18.6958C38.9429 18.7609 39.8765 19.7409 39.8765 20.9346C39.844 22.2026 38.785 23.2058 37.517 23.1733V23.178Z"
        fill="black"
      />
      <path
        d="M46.5276 17.7203V16.587H43.8569V25.2911H46.5323V21.227C46.5323 19.8569 48.0186 19.1184 49.0497 19.1184C49.059 19.1184 49.0683 19.1184 49.0822 19.1184V16.587C48.1022 16.5591 47.1639 16.9772 46.5276 17.7203Z"
        fill="black"
      />
      <path
        d="M72.7609 22.2072C71.8552 22.2072 71.126 22.941 71.126 23.8421C71.126 24.7478 71.8598 25.477 72.7609 25.477C73.6666 25.477 74.3958 24.7431 74.3958 23.8421C74.3958 22.9364 73.662 22.2072 72.7609 22.2072Z"
        fill="black"
      />
      <path
        d="M27.0339 12.7041H24.2053C24.2146 15.0032 23.1277 17.1676 21.2838 18.5378L20.1644 19.3785L24.5026 25.2958H28.0697L24.0752 19.8523C25.9796 17.9619 27.0432 15.3887 27.0293 12.7041H27.0339Z"
        fill="black"
      />
      <path
        d="M19.8205 12.7041H16.9873V25.2958H19.8205V12.7041Z"
        fill="black"
      />
    </Comp>
  );
}

IconKlarna.displayName = "IconKlarna";

export { IconKlarna };
